import { useEffect } from "react";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import config from "src/config/config";
import { theme } from "styled-tools";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PlaceholderImage from 'src/components/Placeholder';
import { Link } from "react-router-dom";

function TowerRushJackpotPromoFun(props: any) {
    const { theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <InformationWrapper>
                <Container>
                    <h1>Climb Higher. Bet Bigger. Win the Ultimate Jackpot.</h1>
                    <p className="top-para">
                        Get ready for the Tower Rush Jackpot! Place your bets on Tower Rush during the promotion period for a chance to <br />win a massive cash prize
                        <br /><br />
                        Promotion Period: <strong>1 September - 31 October 2026</strong>
                    </p>
                    <ImageWrapper className="GTRCard">
                        <Link to="/instant-games/tower-rush">
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.GTRInnerCard}`}
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                        </Link>
                   </ImageWrapper>
                </Container>

                <Container>
                    <h2>How to Claim</h2>
                    <ImageWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.GTRSteps}`}
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </ImageWrapper>
                </Container>

                <Container>
                    <h2>Terms & Conditions</h2>
                    <TermsList>
    <li>Promotion is valid from <strong>1 September to 31 October 2026</strong></li>
                    <li>Players must place a minimum of <strong>50 qualifying bets</strong> on Tower Rush 
    during the promotion period.</li>
                    <li>Only qualifying bets placed during the promotion period will count. </li>
                    <li>The Jackpot prize is <strong>₹30,00,000 (30 Lakhs)</strong></li>
                    <li>The prize will be credited to the eligible winner's wallet.</li>
                    <li>Players must have a valid and active account to participate.</li>
                    <li>Cancelled, voided or invalid bets will not count towards the 
    promotion.</li>
                    <li>Regular Terms & Conditions apply.</li>
                    </TermsList>
                </Container>
            </InformationWrapper>
        </>
    );
}

export default withTheme(withAppContext(TowerRushJackpotPromoFun));

const InformationWrapper = styled.div`
    width: 100%;
    height: auto;
    padding: 1rem 0 5rem 0;
    gap: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    color: #444;
    background-color: #EBEBEB;

    h1, h2, p {
        margin: 0;
        padding: 0;
    }

    h1, h2 {
        width: 100%;
        color: #211E32;
        text-align: center;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        font-family: 'Inter-Bold';
        line-height: normal;
    }

    h1 {
        font-size: 20px;
        text-transform: none;
    }

    h2 {
        font-size: 18px;
        text-transform: capitalize;
    }

    .top-para {
        width: 100%;
        color: #444;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 35px;
        text-transform: none;
    }

    .GTRCard {
        & span {
            display: flex !important;
            justify-content: center !important;
            img {
                width: 35%;
            } 
        }
    }
`;

const Container = styled.div`
    width: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1rem;
    background-color: #fff;
    padding: 2.5rem 1.5rem;
    border-radius: 8px;
`;

const Table = styled.table`
    width: 80%;
    border-collapse: separate;
    border-spacing: 0 10px;
    table-layout: fixed;
    color: #FFF;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    line-height: 35px;
    text-transform: capitalize;
    margin: 0 auto;

    td {
        padding: 1rem;
    }

    thead tr th {
        color: #444;
        font-weight: 400;
    }

    tbody tr {
        background: #734F09;
    }

    tbody tr td {
        font-weight: 600;
    }

    tbody tr td:first-child {
        border-radius: 5px 0 0 5px;
    }
    tbody tr td:last-child {
        border-radius: 0 5px 5px 0;
    }
`;

const ImageWrapper = styled.div`
    width: 85%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    backdrop-filter: blur(7px);
    
    img {
        width: 100%;
    }
`;

const TermsList = styled.ul`
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
    margin: 0 auto;
    padding: 0;
    list-style: none;

    li {
        color: #444;
        font-size: 16px;
        font-style: normal;
        text-align: left;
        font-weight: 400;
        line-height: 27px;
        text-transform: capitalize;
        background: #EBEBEB;
        padding: 12px 1.5rem 12px 2.5rem;
        position: relative;
    }

    li::before {
        content: "✦";
        position: absolute;
        color: #444;
        left: 1.5rem;
        top: 12px;
    }
`;